<header>
  <div class="d-flex">
    <h3 class="title">
        <fa-icon [icon]="['fas', 'sticky-note']" ></fa-icon>&nbsp;
        <span *ngIf="strViewType == 'edit'" >{{ 'edit_note'| translate }} </span>
        <span *ngIf="strViewType == 'add'" >{{ 'create_note'| translate }} </span>
    </h3>
    <div class="ml-auto d-flex">
      <ul class="list-inline pull-right">
        <li class="list-inline-item">
          <fieldmagic-primary-button
            (click)="onSubmit()"
            icon="save"
            label="save"
            [isInProgress]="bShowLoader"
          ></fieldmagic-primary-button>
        </li>
        <li class="list-inline-item">
          <fieldmagic-primary-button
            variant="error"
            (click)="cancelDialog()"
            icon="times"
            label="close"
          ></fieldmagic-primary-button>
        </li>
      </ul>
    </div>
  </div>
</header>
<hr class="separator"/>
<div class="col-12">
  <nav class="pb-3">
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
      <a
        [ngClass]="{'active': activeTab === 'information'}"
        class="nav-item nav-link noradius text-primary pointer record-labels" id="infoTab"
        (click)="switchTab('information')">
        {{ 'information' | translate }}
      </a>
      <a *ngIf="strViewType === 'edit'"
        [ngClass]="{'active': activeTab === 'system'}"
        class="nav-item nav-link noradius text-primary pointer record-labels" id="systemTab"
        (click)="switchTab('system')">
        {{ 'system' | translate }}
      </a>
    </div>
  </nav>
</div>
<div *ngIf="activeTab === 'information'">
  <div class="col-sm-12" *ngIf="notesForm && bPageLoaded">
    <form [formGroup]="notesForm">
      <textarea [required] class="form-control input-textarea" [ngClass]="{'is-invalid': !notesForm.valid && bSubmitted }" maxLength="10000" rows="5" formControlName="note"></textarea>

      <div *ngIf="notesForm.controls['note'].invalid && notesForm.controls['note'].dirty " class="text-danger">
        <small *ngIf="notesForm.controls['note'].errors.maxlength" class="align-self-center"> {{ 'max_character' | translate}} </small>
      </div>

      <fieldmagic-grid>
        <ng-container *ngIf="strModule == 'jobs' || strModule == 'opportunities'">
          <div
            *ngIf="strModule == 'jobs'"
            fieldmagicGridColumn="4"
          >
            <fieldmagic-checkbox-input
              formControlName="include_in_report"
              label="Include in job report"
            >
            </fieldmagic-checkbox-input>
          </div>
          <div fieldmagicGridColumn="4">
            <fieldmagic-checkbox-input
              formControlName="share_in_mobile"
              label="Share in mobile"
            >
            </fieldmagic-checkbox-input>
          </div>
        </ng-container>
        <div fieldmagicGridColumn="4">
          <fieldmagic-checkbox-input
            formControlName="is_sticky_note"
            label="Sticky Note"
          >
          </fieldmagic-checkbox-input>
        </div>
      </fieldmagic-grid>
    </form>
  </div>
  <ng-container *ngIf="!bPageLoaded">
    <div class="col-sm-12" align="center">
      <h4><fa-icon [icon]="['fas', 'spinner']" [spin]="true"></fa-icon></h4>
    </div>
  </ng-container>
</div>

<div *ngIf="activeTab === 'system'">
  <div class="px-3 pb-3">
    <fieldmagic-grid>
      <div fieldmagicGridColumn="6">
        <div class="ng-untouched ng-pristine ng-valid">
            <label class="labels" for="created_at"> {{"created_at" | translate}} </label>
            <input type="text"
              class="form-control
              font-size-11
              input-height-40"
              id="created_at"
              readonly=""
              maxlength="16"
              value="{{ createdAt }}">
        </div>
      </div>
      <div fieldmagicGridColumn="6">
        <div class="ng-untouched ng-pristine ng-valid">
            <label class="labels" for="created_by"> {{"created_by" | translate}} </label>
            <input type="text"
              class="form-control
              font-size-11
              input-height-40"
              id="created_by"
              readonly=""
              maxlength="16"
              value="{{ createdBy }}">
        </div>
      </div>
    </fieldmagic-grid>
  </div>
</div>